<template>
  <div id="cardsContain" class="cardsContain grid">
    <interest-card v-if="showinterests"></interest-card>

    <alert-card :class="alert.id" class="card alertCard" v-for="alert in alerts" v-bind:key="alert.id" :alert="alert"></alert-card>

    <HomeCardListItem v-for="card in cardsData" :card="card" :key="card.id"></HomeCardListItem>
    <infinite-loading @infinite="infiniteHandler" class="cardLoader">
      <div slot="spinner">Loading...</div>
      <div slot="no-more">No further results.</div>
      <div slot="no-results">No further results.</div>
    </infinite-loading>
    <!-- <custom-card></custom-card> -->
    <profile-card></profile-card>
  </div>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import HomeCardListItem from './HomeCardListItem'
  import CustomCard from '../cards/Custom'
  import InterestCard from '../cards/Interests'
  import AlertCard from '../cards/Alert'
  import ProfileCard from '../profile/Profile'
  import { mapState } from 'vuex'

  export default {
    components: {
      InfiniteLoading,
      HomeCardListItem,
      CustomCard,
      InterestCard,
      AlertCard,
      ProfileCard
    },
    data () {
      return {
        currentPage: 1,
        nextPage: 1,
        lastPage: 1,
        cardsData: [],
        infiniteId: +new Date(),
        showinterests: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.user,
        alerts: state => state.alert
      })
    },
    mounted: function () {
      if ((this.user && ((this.user !== undefined) ? this.user.interests.length : 0) < 1)) {
        this.showinterests = true
      }
    },
    methods: {
      infiniteHandler ($state) {
        // console.log('Load more cards')
        this.$store.dispatch('getCards', this.nextPage)
          .then((response) => {
            if (response.status === 200 && response.data.data.length) {
              this.currentPage = this.nextPage
              this.nextPage = this.currentPage + 1
              this.lastPage = response.data.last_page
              this.cardsData = (this.cardsData.length > 0) ? this.cardsData.concat(response.data.data) : response.data.data
              $state.loaded()
            } else {
              $state.complete()
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      checkInterests () {
        return (this.state.user !== undefined) ? this.state.user.interests.length : 0
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/home/HomeCardList.vue